import React from "react";
import { papi } from "@haohan-frontend/papi";
import { storage as i18nStorage } from "@haohan/root-locales";
import BugReportIcon from '@mui/icons-material/BugReport';
import { Box, LinearProgress, Paper, Typography } from "@mui/material";

export interface ErrorBoundaryProps extends React.PropsWithChildren<{
    fallback?: React.ReactNode;
}> {}

export class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    {hasError: boolean}
> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        papi.system.logError({
            message: error.message,
	        stack: info.componentStack,
            href: location.href,
        })
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (
                <Box
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    height='100%'
                >
                    <Paper>
                        <LinearProgress
                            value={100}
                            variant='determinate'
                            color='error'
                        />
                        <Box
                            p={2}
                            width={420}
                            textAlign='center'
                            boxSizing='border-box'
                            maxWidth='100%'
                        >
                            <BugReportIcon sx={{fontSize: 48}} color='error' />
                            <Typography variant="h5" mb={1}>
                                {i18nStorage.t('Error occurred')}
                            </Typography>
                            <Typography variant="body1">
                                {i18nStorage.t('We have forwarded the problem to the developers and are already working on it')}
                            </Typography>
                        </Box>
                    </Paper>
                </Box>
            );
        }

        return this.props.children;
    }
}